import API from './API';

export default {

  // TUTTE le sedi del partner (il backend filtra già sul tenant del token).
  //
  // Serve dove una sede è una DESTINAZIONE — i punti di partenza e arrivo degli
  // spostamenti interni: un dipendente deve poter portare un'auto alla sede di
  // un collega. Da non confondere con `getHeadquartersByEmployee`, che è
  // l'elenco delle sedi DOVE LAVORA e alimenta la scelta della sede della
  // prenotazione (lì il confine resta, e lo impone anche il server).
  getHeadquartersOfPartner() {
    return API.get('/headquarter', { params: { sort: 'name,ASC', limit: 200 } });
  },

  getHeadquartersByEmployee(employeeId) {
    return API.get(`/employee?filter=id||$eq||${employeeId}&`,{
        params: {
             join: [
              'headquarters',
              'headquarters.area',
            ], 
          },
        });
  }, 

  addTask(task) {
    return API.post('/task', task);
  },

  getBookingById(id) {
    return API.get(`/booking/`+ id, {
       params: {
        join: 
        [
          'pickup_bookings', 
          'pickup_bookings.point', 
          'pickup_bookings.driver_pickup', 
          'pickup_bookings.planners', 

          'delivery_bookings',
          'delivery_bookings.point_origin_delivery',
          'delivery_bookings.point_destination_delivery',
          'delivery_bookings.driver_delivery',
          'delivery_bookings.planners', 
          
          'escort_bookings',
          'escort_bookings.point_origin_escort',
          'escort_bookings.point_destination_escort', 
          'escort_bookings.driver_escort',
          'escort_bookings.planners', 

          'customer', 
          'tasks', 
          'car', 
          'headquarter',
          'headquarter.area',
          
        ],
      }, 
    });
  },

  getBookingAttivi(headquarterId,currentDate, tomorrowDate  ) {
    const state = "canceled";
    return API.get(`/booking?filter=state||$ne||${state}&filter=data||$gte||${currentDate}&filter=data||$lte||${tomorrowDate}&filter=headquarter.id||$eq||${headquarterId}&sort=data,ASC`, {
      params: {
        join: ['car','pickup_bookings','delivery_bookings','escort_bookings', 'headquarter', 'customer', 'tasks'],

      },
      order: { data: 'ASC' }
    });
  },

  getBookingFuturi(headquarterId,tomorrowDate) {
    const state = "canceled";
    return API.get(`/booking?filter=state||$ne||${state}&filter=data||$gte||${tomorrowDate}&filter=headquarter.id||$eq||${headquarterId}&sort=data,ASC`, {
      params: {
        join: ['car','pickup_bookings','delivery_bookings','escort_bookings', 'headquarter', 'customer', 'tasks']
      },
    });
  },

  getBookingPassati(headquarterId,currentDate) {
    const state = "canceled";
    return API.get(`/booking?filter=state||$ne||${state}&filter=data||$lt||${currentDate}&filter=headquarter.id||$eq||${headquarterId}&sort=data,ASC`, {
      params: {
        join: ['car','pickup_bookings','delivery_bookings','escort_bookings', 'headquarter', 'customer', 'tasks']
      },
    });
  },

  getBookingAttiviAll(currentDate, tomorrowDate) {
    const state = "canceled";
    return API.get(`/booking?filter=state||$ne||${state}&filter=data||$gte||${currentDate}&filter=data||$lte||${tomorrowDate}&sort=data,ASC`, {
      params: {
        join: ['car','pickup_bookings','delivery_bookings','escort_bookings', 'headquarter', 'customer', 'tasks']
      },
    });
  },

  getBookingFuturiAll(tomorrowDate ) {
    const state ="canceled";
     return API.get(`/booking?filter=state||$ne||${state}&filter=data||$gte||${tomorrowDate}&sort=data,ASC`, {
      params: {
        join: ['car','pickup_bookings','delivery_bookings','escort_bookings', 'headquarter', 'customer', 'tasks']
      },
    })
  },

  getBookingPassatiAll(currentDate) {
    const state = "canceled";
    return API.get(`/booking?filter=state||$ne||${state}&filter=data||$lte||${currentDate}&sort=data,ASC`, {
      params: {
        
        join: ['car','pickup_bookings','delivery_bookings','escort_bookings', 'headquarter', 'customer', 'tasks']
      },
    });
  },

  updateDateBooking(id, data){
    return API.patch('/booking/'+id, data)
  },

  /***************************PICKUP**********************/
  getRangePickup(req){
    return API.post('/pickup/range', req);
  },

  // NOTTURNO: stesso servizio del pickup, listino diverso — ed è il SERVER a
  // sceglierlo, perché dipende dall'ora della corsa (`restaurant_night` fra le
  // 22 e le 6, `restaurant` nelle altre ore). Per questo il corpo porta la
  // `date`, che `/pickup/range` non vuole. La rotta è riservata ai partner
  // `is_restaurant`: a un partner normale risponde 403.
  getRangeRestaurant(req){
    return API.post('/pickup/range-restaurant', req);
  },
  
  updateDatePickup(id,date){
    return API.post('/pickup/update-prenotazione/'+id, date)
  },

  /***************************ESCORT **********************/
  // Servizio RIAPERTO (interruttore DEPRECATE_ESCORT=false).
  // 403 se la sede non e' propria o il partner e' un ristorante.
  getRangeEscort(req){
    return API.post('/escort/range', req);
  },

  updateDateEscort(id, date){
    return API.post('/escort/update-prenotazione/'+id, date)
  },

  /***************************DELIVERY**********************/
  // Servizio ANCORA dismesso (DEPRECATE_DELIVERY): /delivery/range risponde 410.
  // updateDateDelivery resta SOLO per lavorare le corse esistenti (storico in esaurimento).
  updateDateDelivery(id, date){
    return API.post('/delivery/update-prenotazione/'+id, date)
  },


  messageModifyHourBooking(data){
    return API.post('/booking/messageModifyHourBooking/', data)
  },


  messageModifyTaskBooking(data){
    return API.post('/booking/messageModifyBooking/', data)
  },


  deleteBooking(id) {
    return API.get('/booking/delete/' + id);
  },

  deleteTask(id) {
    return API.delete('/task/' + id);
  },


};